import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
class Home extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Terms and Conditions | LA Language Academy Australia</title>
          <meta name="description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/term`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="Terms and Conditions | LA Language Academy Australia" />
          <meta name="twitter:description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/term`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Terms and Conditions | LA Language Academy Australia" />
          <meta property="og:description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <div className="innerPage">
        <Header />
          <div className="hero-section-gray mt-80">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h1 className="primary-heading mb-0 text-uppercase mfw-600">TERMS OF USE</h1>
                  <span className="effective-date">Effective Date: 00-00-0000</span>
                </div>
              </div>
            </div>            
          </div>
          <div className="term-content">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
       
          <ol className="m-0 term-content-list" style={{ listStyleType: 'decimal', paddingLeft: '45px' }}>
 
            {/* 1 */}
            <li>
              <p className="mb-2"><strong>INTRODUCTION AND ACCEPTANCE OF TERMS</strong></p>
              These Terms and Conditions, together with our Privacy Policy, are collectively referred to as
              the "Terms." They govern your access to and use of the website <a href="https://languageacademy.com.au">languageacademy.com.au</a> and
              any associated mobile applications (the "Platform"), operated by Language Academy Australia
              Pty Ltd ("Language Academy," "We," "Us," "Our," or "the Company").
              <p className="pt-2">
                By accessing or using the Platform in any capacity — including browsing, viewing, registering
                an account, or purchasing a subscription — you affirmatively agree to be bound by these Terms.
                If you do not agree, please discontinue use of the Platform immediately.
              </p>
            </li>
 
            {/* 2 */}
            <li>
              <p className="mb-2"><strong>AMENDMENTS TO TERMS</strong></p>
              We reserve the right to amend these Terms at any time. Updated Terms will be posted on the
              Website and will supersede all previous versions. We will not send individual notifications of
              changes. Your continued use of the Platform after any amendments take effect constitutes your
              acceptance of the revised Terms.
            </li>
 
            {/* 3 */}
            <li>
              <p className="mb-2"><strong>USER REPRESENTATIONS AND WARRANTIES</strong></p>
              When registering an account or conducting any transaction on the Platform, you warrant that:
              <ul className="p-0 mt-2">
                <li className="dot-list">You are using your actual identity.</li>
                <li className="dot-list">All personal information you provide is true, accurate, complete, and current.</li>
                <li className="dot-list">You will promptly update your personal information to maintain its accuracy.</li>
              </ul>
              By accessing or using the Platform, you further confirm that:
              <ul className="p-0 mt-2">
                <li className="dot-list">Your use of the Platform is strictly for personal, non-commercial purposes.</li>
                <li className="dot-list">You have a limited right to use the Website and no right to modify, reproduce, copy, distribute, sell, or resell any part of it.</li>
                <li className="dot-list">You will use the Platform only for lawful and reasonable purposes in accordance with these Terms.</li>
                <li className="dot-list">You will not use meta tags or hidden text featuring Language Academy's name or trademarks without prior written consent.</li>
                <li className="dot-list">You will not use the Platform for fraudulent, criminal, or otherwise unlawful activities.</li>
                <li className="dot-list">You will not transmit any material that is illegal, offensive, deceptive, abusive, defamatory, harassing, or otherwise objectionable.</li>
              </ul>
            </li>
 
            {/* 4 */}
            <li>
              <p className="mb-2"><strong>USER ACCOUNTS</strong></p>
              Language Academy may offer user accounts linked to your email address and/or phone number. By
              registering an account or using the Platform as a guest, you agree that:
              <ul className="p-0 mt-2">
                <li className="dot-list">You are solely responsible for maintaining the confidentiality of your account credentials and for all activity conducted under your account.</li>
                <li className="dot-list">You will notify us immediately if you suspect any unauthorised access or use of your account.</li>
                <li className="dot-list">You will keep your account information accurate and up to date.</li>
                <li className="dot-list">You will comply with any additional procedures or guidelines relating to use of the Platform, as updated from time to time.</li>
                <li className="dot-list">You will adhere to all applicable laws and regulations in your jurisdiction.</li>
              </ul>
              <i>
                Language Academy reserves the right to deny access, suspend, or terminate any account without
                notice if we reasonably believe it is being used for unauthorised or unlawful purposes.
              </i>
            </li>
 
            {/* 5 — NEW */}
            <li>
              <p className="mb-2"><strong>PURCHASES AND AUTOMATICALLY RENEWING SUBSCRIPTIONS(For Mobile APP)</strong></p>
              PTE Practice & AI Mock Tests may offer products and services for purchase through the Apple App Store,
              Google Play Store, or other external services authorised by PTE Practice & AI Mock Tests (each, an
              "External Service," and any purchase made thereon, an "External Service Purchase"). PTE Practice & AI Mock Tests
               may also offer products and services for purchase via credit card, debit card, UPI, or
              other payment methods on the Platform ("Internal Purchases").
              <p className="mt-2">
                Subscriptions may be offered as automatically renewing unless otherwise stated. If you cancel
                your subscription, you will continue to have access to its benefits until the end of your current
                billing cycle, after which it will expire. Cancelling a subscription does not remove your profile
                from the Services. If you wish to fully delete your account, you must do so in accordance with
                Section 6 (Account Termination).
              </p>
 
              <div className="mt-3">
                <strong>5a. External Service Purchases and Subscriptions</strong>
                <p className="mt-2">
                  When you make a purchase via an External Service (e.g., Apple ID or Google Play), your
                  External Service account will be charged in accordance with the terms disclosed at the time of
                  purchase and the general terms of your External Service provider. Taxes may apply based on
                  your location.
                </p>
                <p className="mt-2">
                  If your External Service Purchase includes an automatically renewing subscription, your
                  External Service account will continue to be charged at the agreed rate and interval until you
                  cancel. To cancel, you must manage your subscription directly within your External Service
                  account — even if you have deleted the PTE Practice & AI Mock Tests app or deactivated your profile.
                </p>
                <p className="mt-2">For example:</p>
                <ul className="p-0 mt-1">
                  <li className="dot-list"><strong>Apple ID:</strong> Go to Settings &gt; iTunes &amp; App Stores &gt; Apple ID &gt; View Apple ID &gt; Subscriptions and cancel PTE Practice & AI Mock Tests.</li>
                  <li className="dot-list"><strong>Google Play:</strong> Go to Google Play app &gt; Menu &gt; My Apps &gt; Subscriptions, find PTE Practice & AI Mock Tests, and cancel.</li>
                </ul>
                <p className="mt-2">
                  If you initiate a chargeback or reverse a payment through an External Service, PTE Practice & AI Mock Tests
                   reserves the right to terminate your account immediately. Should the chargeback be
                  overturned, please contact PTE Practice & AI Mock Tests Support. Certain users may be entitled to a
                  refund in accordance with Section 5d.
                </p>
              </div>
 
              <div className="mt-3">
                <strong>5b. Internal Purchases and Subscriptions</strong>
                <p className="mt-2">
                  If you make an Internal Purchase, you agree to pay the amount displayed along with any
                  applicable taxes. You authorise PTE Practice & AI Mock Tests to charge your provided payment method
                  ("Payment Method"), and we may correct any billing errors, even if payment has already been
                  requested or received.
                </p>
                <p className="mt-2">
                  If your subscription includes automatic renewal, your Payment Method will be charged at the
                  agreed interval unless cancelled. You can manage or cancel subscriptions by visiting Settings
                  &gt; My Orders within the Platform.
                </p>
                <p className="mt-2">
                  You may update your Payment Method in the settings section. If we are unable to process your
                  payment, you authorise us to attempt again using updated information from your provider. You
                  remain responsible for any unpaid charges.
                </p>
                <p className="mt-2">
                  Chargebacks or reversed payments may result in immediate termination of your account. If a
                  reversal is overturned, please contact PTE Practice & AI Mock Tests Support. Refund eligibility is outlined
                  in Section 5d.
                </p>
              </div>
 
              <div className="mt-3">
                <strong>5c. Virtual/Digital Items</strong>
                <p className="mt-2">
                  PTE Practice & AI Mock Tests may offer limited-use, non-transferable, non-sublicensable, revocable
                  licences for virtual or digital items ("Virtual Items") through its Platform. These items are for
                  entertainment or functionality purposes within the Services and do not represent monetary value
                  or real-world currency.
                </p>
                <p className="mt-2">
                  You may only purchase Virtual Items through PTE Practice & AI Mock Tests or its authorised partners.
                  PTE Practice & AI Mock Tests retains ownership of all Virtual Items, and you acknowledge that their
                  perceived value may change or be revoked at any time, with or without notice. PTE Practice & AI Mock Tests
                  has no liability for such changes and prohibits the transfer or resale of Virtual Items.
                </p>
                <p className="mt-2">
                  All Virtual Item purchases and redemptions are final and non-refundable. Deleting your account
                  or account termination (voluntary or involuntary) does not entitle you to compensation or refund
                  for unused Virtual Items.
                </p>
              </div>
 
              <div className="mt-3">
                <strong>5d. Refunds</strong>
                <p className="mt-2">
                  The purchase and sale of subscriptions is considered complete upon successful payment.
                  However, PTE Practice & AI Mock Tests provides a refund window of up to three (3) working days from the
                  date of payment, provided the subscription has not been used in any manner. "Use" of a
                  subscription includes but is not limited to sending or receiving messages, viewing other user
                  profiles, and updating your own profile or account details.
                </p>
                <p className="mt-2">
                  If none of the above actions have been taken, you may request a full refund within the 3-day
                  window. Once approved, PTE Practice & AI Mock Tests will issue the refund immediately, though your bank
                  or card issuer may take 5–15 days to reflect the refund in your account or statement.
                </p>
                <p className="mt-2">
                  If your subscription remains unused, you may let it expire naturally without further renewal.
                  Subscription balances do not carry real-world monetary value and do not accrue interest or
                  stored value. Upon account deletion, PTE Practice & AI Mock Tests reserves the right to redeem or forfeit
                  any unused subscription balance.
                </p>
                <p className="mt-2">
                  If PTE Practice & AI Mock Tests terminates your account due to a violation of this Agreement, you will not
                  be entitled to any refund.
                </p>
              </div>
            </li>
 
            {/* 6 — NEW */}
            <li>
              <p className="mb-2"><strong>ACCOUNT TERMINATION(For Mobile APP)</strong></p>
              You may deactivate your account at any time by logging into the PTE Practice & AI Mock Tests Website or
              App, navigating to the "Settings" section, and following the instructions to deactivate or delete
              your account. Please note that deactivating your account does not cancel any subscriptions
              purchased through an External Service (such as Apple App Store or Google Play). You must manage
              or cancel such subscriptions directly through your External Service account to avoid continued
              billing.
              <p className="mt-2">
                PTE Practice & AI Mock Tests reserves the right to investigate, suspend, or permanently terminate your
                account at any time, at its sole discretion, with or without prior warning. Grounds for such
                action include, but are not limited to:
              </p>
              <ul className="p-0 mt-2">
                <li className="dot-list">Violation of these Terms;</li>
                <li className="dot-list">Misuse of the Services;</li>
                <li className="dot-list">Engaging in inappropriate, fraudulent, abusive, or unlawful behaviour, whether on or off the Platform;</li>
                <li className="dot-list">Uploading prohibited content or attempting to bypass moderation tools.</li>
              </ul>
              <p className="mt-2">
                In some cases, we may issue a warning before termination, but we are not obligated to do so.
                Termination may be immediate if the violation is deemed severe or if required by law or policy.
              </p>
              <p className="mt-2">
                If your account is terminated by you or by PTE Practice & AI Mock Tests for any reason, this Agreement
                remains in effect and you will not be entitled to any refund or compensation for any purchases
                or unused subscriptions.
              </p>
              <p className="mt-2">
                PTE Practice & AI Mock Tests may, under certain circumstances and at its sole discretion, allow reactivation
                of accounts that were previously deactivated or terminated. This is assessed subject to
                eligibility and platform policies.
              </p>
              <p className="mt-2">
                Your personal data, including your content and communications, will be maintained or deleted in
                accordance with our Privacy Policy, and residual data may be retained to comply with legal
                obligations, enforce our policies, or resolve disputes.
              </p>
            </li>
 
            {/* 7 — was 5 */}
            <li>
              <p className="mb-2"><strong>SUBSCRIPTION PLANS</strong></p>
              Language Academy offers the following paid subscription plans providing access to the Platform's
              learning features. All prices are listed in Indian Rupees (INR) unless otherwise stated.
 
              <div className="mt-3">
                <strong>7.1 Silver Plan</strong>
                <p>The Silver Plan includes:</p>
                <ul className="p-0">
                  <li className="dot-list">Unlimited AI scoring for all question types</li>
                  <li className="dot-list">Full access to exam questions</li>
                  <li className="dot-list">Access to the latest templates and prediction files</li>
                  <li className="dot-list">Unlimited sectional mock tests with scoring</li>
                  <li className="dot-list">Unlimited full mock tests with scoring</li>
                  <li className="dot-list">Unlimited comprehensive mock tests with scoring</li>
                </ul>
                <strong>Silver Plan Pricing (Auto-Renewing):</strong>
                <ul className="p-0">
                  <li className="dot-list">1 Month: INR 1,549 — Auto-renews every 1 month</li>
                  <li className="dot-list">2 Months: INR 2,499 — Auto-renews every 2 months (19% off, was INR 3,098)</li>
                  <li className="dot-list">3 Months: INR 3,499 — Auto-renews every 3 months (25% off, was INR 4,647)</li>
                </ul>
              </div>
 
              <div className="mt-4">
                <strong>7.2 Gold Plan</strong>
                <p>The Gold Plan includes everything in the Silver Plan, plus:</p>
                <ul className="p-0">
                  <li className="dot-list">Access to reading explanation videos (VIP)</li>
                  <li className="dot-list">Full access to premium strategy videos (VIP)</li>
                  <li className="dot-list">Full access to the detailed video course (VIP)</li>
                </ul>
                <strong>Gold Plan Pricing (Auto-Renewing):</strong>
                <ul className="p-0">
                  <li className="dot-list">1 Month: INR 4,799 — Auto-renews every 1 month</li>
                  <li className="dot-list">2 Months: INR 6,999 — Auto-renews every 2 months (27% off, was INR 9,598)</li>
                  <li className="dot-list">3 Months: INR 7,999 — Auto-renews every 3 months (44% off, was INR 14,397)</li>
                </ul>
              </div>
              <p className="mt-3"><i>Language Academy reserves the right to modify pricing with reasonable notice.</i></p>
            </li>
 
            {/* 8 — was 6 */}
            <li>
              <p className="mb-2"><strong>AUTOMATIC RECURRING BILLING (AUTO-DEBIT)</strong></p>
 
              <div className="mt-2">
                <strong>8.1 Authorisation</strong> By purchasing a Silver or Gold subscription, you expressly authorise
                Language Academy Australia Pty Ltd to automatically charge your nominated payment method at
                the end of each subscription period (1 month, 2 months, or 3 months, as applicable) without any
                further action required from you.
              </div>
              <div className="mt-2">
                <strong>8.2 Renewal</strong> Your subscription will automatically renew at the end of each billing cycle at
                the then-current rate for your selected plan and billing period. You will not receive a separate
                reminder before each renewal charge is processed.
              </div>
              <div className="mt-2">
                <strong>8.3 Payment Failure</strong> If your payment method is declined or fails, we may attempt to process
                the charge again. If payment cannot be successfully collected, your subscription access may be
                suspended or cancelled until the outstanding amount is settled.
              </div>
              <div className="mt-2">
                <strong>8.4 Price Changes</strong> We reserve the right to change subscription pricing. If pricing changes,
                we will provide reasonable notice before the change takes effect. Your continued subscription
                after the effective date of the price change constitutes acceptance of the new pricing.
              </div>
              <div className="mt-2">
                <strong>8.5 Cancellation of Auto-Debit</strong> You may cancel the automatic renewal of your subscription
                at any time by:
                <ul className="p-0 mt-2">
                  <li className="dot-list">Visiting the "Your Subscriptions" section in your account dashboard, or</li>
                  <li className="dot-list">Contacting us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> before your next renewal date.</li>
                </ul>
                Cancellation will take effect at the end of the current billing cycle. You will retain access to your
                subscription features until the end of the period for which you have already paid. No partial
                refunds will be issued for unused time within a billing period unless required by applicable law.
              </div>
            </li>
 
            {/* 9 — was 7 */}
            <li>
              <p className="mb-2"><strong>REFUND POLICY(For Website)</strong></p>
              All subscription fees are non-refundable except where required by applicable consumer protection
              law. If you believe you have been charged in error, please contact us at{' '}
              <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> within 7 days of the charge.
            </li>
 
            {/* 10 — was 8 */}
            <li>
              <p className="mb-2"><strong>ELECTRONIC COMMUNICATIONS</strong></p>
              By using the Platform or communicating with us electronically, you consent to receive
              communications from us via electronic means, including email and in-app notifications. This
              includes billing notices, renewal reminders, and updates to these Terms.
            </li>
 
            {/* 11 — was 9 */}
            <li>
              <p className="mb-2"><strong>INTELLECTUAL PROPERTY</strong></p>
              All content on the Platform, including but not limited to text, graphics, videos, mock tests,
              templates, and prediction files, is the property of Language Academy Australia Pty Ltd or its
              content suppliers and is protected by applicable intellectual property laws. Unauthorised
              reproduction, distribution, or commercial use of any content is strictly prohibited.
            </li>
 
            {/* 12 — was 10 */}
            <li>
              <p className="mb-2"><strong>LIMITATION OF LIABILITY</strong></p>
              To the maximum extent permitted by law, Language Academy shall not be liable for any indirect,
              incidental, special, or consequential damages arising from your use of the Platform or any
              subscription service. Our total liability to you for any claim shall not exceed the total amount
              paid by you in the three (3) months preceding the claim.
            </li>
 
            {/* 13 — was 11 */}
            <li>
              <p className="mb-2"><strong>GOVERNING LAW</strong></p>
              These Terms are governed by and construed in accordance with the laws of New South Wales,
              Australia. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction
              of the courts of New South Wales.
            </li>
 
            {/* 14 — was 12 */}
            <li>
              <p className="mb-2"><strong>CONTACT US</strong></p>
              For any questions, billing enquiries, or cancellation requests, please contact us:
              <br />
              <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> |{' '}
              <a href="https://www.languageacademy.com.au" target="_blank" rel="noopener noreferrer">www.languageacademy.com.au</a>
              <br /><br />
              <i>
                Language Academy Australia Pty Ltd reserves the right to modify, suspend, or discontinue any
                aspect of the Platform or its subscription plans at any time with reasonable notice.
              </i>
            </li>
 
          </ol>
        
      </div>
    </div>
  </div>
</div>
        <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
